import { useCallback, useState } from 'react';
import { storageKeys } from '@/config/app';
import { local } from '@/lib/storage';

export type CatalogLayout = 'grid' | 'natural';
export type CardSize = 's' | 'm' | 'l';

/** Раскладка и размер карточек сохраняются между визитами (CAT-7); по умолчанию Natural · M. */
export function useCatalogPrefs() {
  const [layout, setLayoutState] = useState<CatalogLayout>(() =>
    local.get(storageKeys.catalogLayout) === 'grid' ? 'grid' : 'natural',
  );
  const [size, setSizeState] = useState<CardSize>(() => {
    const stored = local.get(storageKeys.catalogSize);
    return stored === 's' || stored === 'l' ? stored : 'm';
  });

  const setLayout = useCallback((next: CatalogLayout) => {
    local.set(storageKeys.catalogLayout, next);
    setLayoutState(next);
  }, []);

  const setSize = useCallback((next: CardSize) => {
    local.set(storageKeys.catalogSize, next);
    setSizeState(next);
  }, []);

  return { layout, size, setLayout, setSize };
}
